import { types } from 'mobx-state-tree';

import Price from './Price';

const ProductPriceInfo = types
  .model('ProductPriceInfo', {
    discount_percentage: types.maybeNull(types.number),
    is_discount: types.boolean,
    lower_price: types.maybeNull(types.number),
    normal_price: Price,
    price: Price,
    valid_until: types.maybeNull(types.string),
    valid_until_html: types.maybeNull(types.string),
  })
  .views((self) => {
    return {
      getSavings(withTax) {
        return self.getNormalPrice(withTax) - self.getPrice(withTax);
      },
      getPrice(withTax) {
        return self.price.getPrice(withTax);
      },
      getNormalPrice(withTax) {
        return self.normal_price.getPrice(withTax);
      },
    };
  });

export default ProductPriceInfo;
